import { connect } from 'react-redux';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';

// Components
import DealerInfo from './DealerInfo';

// Selectors
import {
  getDealerContact,
  getDealerName,
  getDealerCountryCode
} from 'store/reducers/dealerSettings/selectors';
import { getLocaleCode } from 'store/reducers/dealerLocale/selectors';

const mapStateToProps = state => ({
  dealerContact: getDealerContact(state),
  dealerName: getDealerName(state),
  locale: getLocaleCode(state),
  dealerCountryCode: getDealerCountryCode(state)
});

export default compose(
  injectIntl,
  connect(
    mapStateToProps,
    null
  )
)(DealerInfo);



// WEBPACK FOOTER //
// ./src/components/atoms/DealerInfo/DealerInfoContainer.js